import { render, staticRenderFns } from "./copy-clipboard.vue?vue&type=template&id=dbe5eaa0"
import script from "./copy-clipboard.vue?vue&type=script&lang=js"
export * from "./copy-clipboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports